// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelokaForm_root__3hxol","row":"TravelokaForm_row__mn_uf"};